import jwt_decode from "jwt-decode";
import * as Sentry from "@sentry/react";
import Fetch from "../components/Fetch";


export async function signIn({ email, password, reCaptcha }) {
  try {
    const response = await Fetch.post("/auth/login", {
      email: email ? email.replace(/ /g, "") : "",
      password,
      reCaptcha
    });
    if (!response.data?.token) {
      return null
    }

    const userData = jwt_decode(response.data.token);
    if (process.env.REACT_APP_SENTRY_DSN) {
      Sentry.setUser({
        username: userData?.name,
        email: userData?.email,
        segment: userData?.company,
        cnpj: userData?.cnpj
      });
    }
    return {
      token: response.data?.token,
      user: userData,
    };
  } catch (error) {
    return;
  }
}


